import { useEffect } from 'react';

const useHashNavigation = () => {
  useEffect(() => {
    // Only run if there's a hash in the URL
    if (!window.location.hash) return;

    const handleHashNavigation = () => {
      const hash = window.location.hash.substring(1);
      if (!hash) return;

      // Wait a bit for sections to load, then scroll
      const scrollToSection = () => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        } else {
          // If element not found, try again after a short delay
          setTimeout(scrollToSection, 100);
        }
      };

      // Start scrolling after a short delay
      setTimeout(scrollToSection, 500);
    };

    // Run hash navigation
    handleHashNavigation();
  }, []); // Empty dependency array - only run once on mount
};

export default useHashNavigation;
